export const SELECT_QUERY_ROW_HEIGHT = 40;